import { AdHawkIcons } from './icons';

export const AdHawkConstants = {
  icons: AdHawkIcons,
} as const;
